<template>
   <div>
      <el-card class="template-parent">
        <h2> Create template </h2>
        <el-input 
            @input="removeError" 
            class="template-title" 
            placeholder="enter template title" 
            v-model="templatetitle"> 
        </el-input>  
        <p class="error" v-if="this.emptyTitleError == true"> title is required </p> 

        <ckeditor :editor="editor" v-model="templatetext" :config="editorConfig"></ckeditor>
        
        <div class="button-parent">
            <el-button type="primary" class="form-button" @click="saveTemplate"> Save </el-button>
        
            <el-button class="form-button" @click="closeForm"> Cancel </el-button>
        </div>

      </el-card>

      <div class="overlay-back"></div>

   </div>
</template>

<script>

import ClassicEditor from "@/CKeditorCustom/ckeditor5/build/ckeditor.js";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import EventService from "@/services/EventService.js";

export default {
  props: {
      propertyid: String,
      issueid: String
  },
  components: {
      ckeditor: CKEditor.component
  },
  data(){
      return{
         templatetitle : "",
         templatetext  : "",
         editor: ClassicEditor,
         emptyTitleError: false,
         editorConfig: {
    	                toolbar: {
                                  items: [
                                         'heading',
                                         '|',
                                         'bold',
                                         'italic',
                                         'bulletedList',
                                         'numberedList',
                                         'todoList',
                                         '|',
                                         'alignment',
                                         '|',
                                         'undo',
                                         'redo'
                                         ]
    	      		             }            
                        },
 
        }
   },
   methods: {
       saveTemplate(){

            if(this.templatetitle == "" || this.templatetitle == null)
            {
                this.emptyTitleError = true;
                return;
            }
 
            var templateInfoObject = {
                        templatetitle : this.templatetitle,
                        templatetext  : escape(this.templatetext),
                        propertyid    : this.propertyid,
                        issueid       : this.issueid
            }

            EventService.createTemplate(templateInfoObject).then( response => {
                this.$emit("new-template-added", response.data);
                this.closeForm();
            })
       },
       closeForm(){
          this.$emit("close-create-template");
       },
       removeError(){
           this.emptyTitleError = false;
       }
   }
}
</script>

<style scoped>
    .template-parent{
        width: 100%;
        margin: auto;
        color: rgb(102, 102, 102);
        position: absolute;
        z-index: 10;
        background-color: white;
        max-width: 800px;
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
        max-height: 70%;
        overflow-y: scroll;
        left: 50%;
        top: 40%;
        transform: translate(-50%,-50%);
    }
   .overlay-back {
        position   : absolute;
        top        : 0;
        left       : 0;
        width      : 100%;
        height     : 100%;
        background : #000;
        opacity    : 0.6;
        filter     : alpha(opacity=60);
        z-index    : 5;
    }
    .template-title{
        padding-bottom: 30px;
        max-width: 450px;
    }
    .button-parent{
        text-align: center;
    }
    .form-button{
        margin: 10px 20px;
    }
    .error{
        color: red;
        font-size: 12px;
        margin: -18px 15px 15px 0px;
  }

</style>
